require('angular').module('wowApp.common')
    .directive('wowSocialButtons', ['AnalyticsService', require('./social-buttons.directive')]);



// WEBPACK FOOTER //
// ./src/common/socialmedia/index.js